import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import { Button, Card, CardContent, Grid, Switch, Table, TableBody, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ClientStatus } from "../../../../config";
import { getAllSuperAdminByFilterThunk } from "../../../../redux/userManagement/userManagementThunk";
import { apiGatewayAxiosInstance } from "../../../../utils/axios";
import TablePaginationShowPage from "../../../../utils/tablePagination";
import FetchingSpinner from "../../../components/FetchingSpinner";
import NoRecords from "../../../components/NoRecords";
import StyledTableCell from "../../../components/StyledTableCell";
import StyledTableRow from "../../../components/StyledTableRow";
import FilterAllSuperAdminModel from "./FilterAllSuperAdminModel";
import RefreshButton from "../../../../utils/refreshButton";
import AdjustStyledTableCell from "../../../../utils/AdjustStyledTableCell";

export default function ListSuperAdmin({ setShowAddSuperAdminForm }) {
    const [isGetAllSuperAdminLoading, setIsGetAllSuperAdminLoading] = useState(false);
    const [superAdminDetails, setSuperAdminDetails] = useState([]);
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [totalSuperAdminCount, setTotalSuperAdminCount] = useState(0);
    const [open, setOpen] = React.useState(false);
    const [reload, setReload] = useState(false);
    const [searchParams, setSearchParams] = React.useState({
        name: "",
        email: "",
        mobileNumber: "",
        status: "",
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const reloadList = () => {
        setReload(!reload);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleAddSuperAdmin = () => {
        setShowAddSuperAdminForm(true);
    };

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setPageSize(parseInt(event.target.value));
        setCurrentPage(0);
    };

    const updateSuperAdminStatus = async (superAdminId, newStatus) => {
        const resp = await apiGatewayAxiosInstance.post(
            "/user_management/super-admin/update-status-by-id",
            {},
            { params: { _id: superAdminId, status: newStatus } },
        );
    };

    const handleStatusToggle = async (superAdminId, newStatus) => {
        try {
            setIsGetAllSuperAdminLoading(true);
            await updateSuperAdminStatus(superAdminId, newStatus);
            const result = await dispatch(
                getAllSuperAdminByFilterThunk({
                    currentPage: currentPage + 1,
                    pageSize,
                    searchParams,
                }),
            ).unwrap();
            setSuperAdminDetails(result.data);
            setTotalSuperAdminCount(result.totalCount);
            setIsGetAllSuperAdminLoading(false);
        } catch (error) {
            console.error("Failed to update status:", error);
        }
    };

    const handleClickSearch = async searchParams => {
        setIsGetAllSuperAdminLoading(true);
        setCurrentPage(0);
        setSearchParams(searchParams);
        const result = await dispatch(
            getAllSuperAdminByFilterThunk({
                currentPage: currentPage + 1,
                pageSize,
                searchParams,
            }),
        ).unwrap();
        setSuperAdminDetails(result.data);
        setTotalSuperAdminCount(result.totalCount);
        handleClose();
        setIsGetAllSuperAdminLoading(false);
    };

    useEffect(async () => {
        setIsGetAllSuperAdminLoading(true);
        await dispatch(
            getAllSuperAdminByFilterThunk({
                currentPage: currentPage + 1,
                pageSize,
                searchParams,
            }),
        )
            .unwrap()
            .then(({ data, totalCount }) => {
                setSuperAdminDetails(data);
                setTotalSuperAdminCount(totalCount);
            });
        setIsGetAllSuperAdminLoading(false);
    }, [currentPage, pageSize, searchParams, reload]);

    return (
        <Box>
            <Grid container mb={4} className="listHeader">
                <Grid item md={6}>
                    <Typography variant="h3">Super Admin</Typography>
                </Grid>
                <Grid item md={6} className="listHeaderFilter">
                    <Grid width={"100%"} justifyContent={"flex-end"} display={"flex"}>
                        <RefreshButton loading={isGetAllSuperAdminLoading} onClick={reloadList} />
                        <Button sx={{ marginRight: "10px", marginLeft: "10px" }} variant="contained" onClick={handleClickOpen}>
                            Filter
                        </Button>
                        <Button variant="contained" onClick={handleAddSuperAdmin}>
                            Add New Super Admin
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <Card className="border border-secondary-50">
                    <CardContent sx={{ padding: 0 }}>
                        {isGetAllSuperAdminLoading ? (
                            <FetchingSpinner />
                        ) : superAdminDetails.length > 0 ? (
                            <TableContainer className="table-container" sx={{ maxHeight: "70vh" }}>
                                <Table stickyHeader aria-label="customized table">
                                    <TableHead className="p-3 mb-2 row">
                                        <TableRow>
                                            <StyledTableCell className="col-1 tableHeaderFont" align="center">
                                                Sr No
                                            </StyledTableCell>
                                            <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                Name
                                            </StyledTableCell>

                                            <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                Email
                                            </StyledTableCell>

                                            <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                Mobile Number
                                            </StyledTableCell>

                                            <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                Created By
                                            </StyledTableCell>
                                            <StyledTableCell className="col-1 tableHeaderFont" align="center">
                                                Status
                                            </StyledTableCell>
                                            <StyledTableCell className="col-1 tableHeaderFont" align="center">
                                                Action
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {superAdminDetails?.map((superAdmin, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell className="tableContentFont" align="center">
                                                    {currentPage * pageSize + index + 1}
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="left">
                                                    <AdjustStyledTableCell content={superAdmin.name} size={30} />
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="left">
                                                    <AdjustStyledTableCell content={superAdmin.email} size={30} />
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="left">
                                                    <AdjustStyledTableCell content={superAdmin.mobileNumber} size={30} />
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="left">
                                                    <AdjustStyledTableCell content={superAdmin?.createdByName} size={30} />
                                                </StyledTableCell>
                                                <StyledTableCell className="tableContentFont" align="left">
                                                    {superAdmin.status == ClientStatus.Active ? (
                                                        <label
                                                            className="text-success centered"
                                                            style={{
                                                                fontWeight: "600",
                                                            }}
                                                        >
                                                            <Grid className="active-dot"></Grid>
                                                            {superAdmin.status}
                                                        </label>
                                                    ) : (
                                                        <label
                                                            className="text-danger centered"
                                                            style={{
                                                                fontWeight: "600",
                                                            }}
                                                        >
                                                            <Grid className="inactive-dot"></Grid>
                                                            {superAdmin.status}
                                                        </label>
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableContentFont" align="center">
                                                    {(superAdmin.status === ClientStatus.Active || superAdmin.status === ClientStatus.InActive) && (
                                                        <Switch
                                                            checked={superAdmin.status === ClientStatus.Active}
                                                            onChange={e => {
                                                                const newStatus = e.target.checked ? ClientStatus.Active : ClientStatus.InActive;
                                                                handleStatusToggle(superAdmin._id, newStatus);
                                                            }}
                                                            color="success"
                                                            inputProps={{ "aria-label": "Activate or Deactivate Super Admin" }}
                                                        />
                                                    )}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <NoRecords />
                        )}

                        {totalSuperAdminCount > 0 && (
                            <Grid
                                className="my-2"
                                style={{
                                    zIndex: "2",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: 2,
                                }}
                            >
                                <Grid
                                    style={{
                                        zIndex: "2",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        padding: 5,
                                    }}
                                >
                                    <Grid
                                        style={{
                                            marginTop: "15px",
                                        }}
                                    >
                                        Total Super Admins: {totalSuperAdminCount}
                                    </Grid>
                                    <Grid justifyContent={"center"} mt={3}>
                                        <TablePaginationShowPage
                                            rowsPerPageOptions={[5, 10, 25, 100]}
                                            colSpan={3}
                                            count={totalSuperAdminCount}
                                            rowsPerPage={pageSize}
                                            page={currentPage}
                                            slotProps={{
                                                select: {
                                                    "aria-label": "Rows per page",
                                                },
                                                actions: {
                                                    showFirstButton: true,
                                                    showLastButton: true,
                                                    slots: {
                                                        firstPageIcon: FirstPageRoundedIcon,
                                                        lastPageIcon: LastPageRoundedIcon,
                                                        nextPageIcon: ChevronRightRoundedIcon,
                                                        backPageIcon: ChevronLeftRoundedIcon,
                                                    },
                                                },
                                            }}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </CardContent>
                    {open && (
                        <FilterAllSuperAdminModel
                            open={open}
                            searchParams={searchParams}
                            setSearchParams={setSearchParams}
                            handleClose={handleClose}
                            handleClickSearch={handleClickSearch}
                        />
                    )}
                </Card>
            </Grid>
        </Box>
    );
}
